import type { ContractDetail } from '../api.js';

type Status = ContractDetail['status'];

/**
 * Statuses where signing has actually been initiated. The Signering tab
 * leads the strip and is the default on navigation.
 */
export const SIGNING_PHASE_STATUSES: ReadonlySet<Status> = new Set<Status>([
  'awaiting_manual_signature',
  'sent',
  'viewed',
  'awaiting_signature',
  'signed',
]);

/**
 * What the Signering tab shows (ADR-0100). Before signing is started
 * (draft, pending = "Klar för granskning", in_review) the tab always shows
 * the signing plan, so author and reviewer see the planned signers and
 * method throughout review; the send cockpit (SigningPanel) takes over only
 * once the user presses "Fortsätt till signering" (`proceeding`), so the
 * optional review is never silently skipped. A cancelled contract shows the
 * cockpit (resend) once the user proceeds.
 */
export function signingTabState(
  status: Status,
  proceeding: boolean,
): { available: boolean; panel: 'plan' | 'cockpit' | null } {
  if (status === 'draft' || status === 'in_review') return { available: true, panel: 'plan' };
  if (status === 'pending') return { available: true, panel: proceeding ? 'cockpit' : 'plan' };
  if (SIGNING_PHASE_STATUSES.has(status)) return { available: true, panel: 'cockpit' };
  if (status === 'cancelled' && proceeding) return { available: true, panel: 'cockpit' };
  return { available: false, panel: null };
}
